import actions from './actions'

const initState = {
    TaskOfSystem: {},
    TaskOfUserSystem: {},
    chartEventObject: [],
    chartObjectEvent: [],
    chartCollectedByTier: [],
    chartUserTask: [],
    chartOrgTask: [],
    chartUserCollected: [],
    chartObjectEventIndex: {
        total: 0,
        page_number: 1,
    },
    chartEventObjectIndex: {
        total: 0,
        page_number: 1,
    },
    useIn: '',
    dataEvent: [],
    dataEventYear: [],
    dataTask: [],
    totalTask: 0,
    pageNumber: 0,
}

const chartReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.GET_LIST_DATA_TASK_USER:
            return {
                ...state,
                ...{
                    pageNumber: action.payload.page_number,
                },
            }
        case actions.type.GET_LIST_DATA_TASK_ADMIN:
            return {
                ...state,
                ...{
                    pageNumber: action.payload.page_number,
                },
            }
        case actions.type.GET_LIST_DATA_TASK_DONE:
            return {
                ...state,
                ...{
                    dataTask: action.payload.isRefresh
                        ? action.payload.data
                        : state.dataTask.concat(action.payload.data),
                    totalTask: action.payload.total,
                },
            }
        case actions.type.GET_LIST_DATA_EVENT_DASHBOARD_DONE:
            if (action.payload.mode) {
                return {
                    ...state,
                    ...{
                        dataEventYear: action.payload.data,
                    },
                }
            } else {
                return {
                    ...state,
                    ...{
                        dataEvent: action.payload.data,
                    },
                }
            }

        case actions.type.LOAD_DATA_CHART_USER_COLLECTED_DONE:
            return {
                ...state,
                ...{
                    chartUserCollected: action.payload.data,
                },
            }
        case actions.type.LOAD_DATA_CHART_ORG_TASK_DONE:
            return {
                ...state,
                ...{
                    chartOrgTask: action.payload.data,
                },
            }
        case actions.type.LOAD_DATA_CHART_USER_TASK_DONE:
            return {
                ...state,
                ...{
                    chartUserTask: action.payload.data,
                },
            }
        case actions.type.LOAD_DATA_TASK_USER_AND_SYSTEM_DONE:
            return {
                ...state,
                ...{
                    TaskOfUserSystem: action.payload.data,
                },
            }
        case actions.type.LOAD_DATA_TASK_SYSTEM_CHART_DONE:
            return {
                ...state,
                ...{
                    TaskOfSystem: action.payload.data,
                },
            }
        case actions.type.LOAD_DATA_CHART_EVENT_OBJECT_DONE:
            return {
                ...state,
                ...{
                    chartEventObject: action.payload.isRefresh
                        ? action.payload.data
                        : state.chartEventObject.concat(action.payload.data),
                    chartEventObjectIndex: action.payload.index,
                },
            }
        case actions.type.LOAD_DATA_CHART_OBJECT_EVENT_DONE:
            console.log('action.payload.data', action.payload)
            return {
                ...state,
                ...{
                    chartObjectEvent: action.payload.isRefresh
                        ? action.payload.data
                        : state.chartObjectEvent.concat(action.payload.data),
                    chartObjectEventIndex: action.payload.index,
                },
            }

        case actions.type.LOAD_DATA_COLECTED_BY_TIER_DONE:
            return {
                ...state,
                ...{ chartCollectedByTier: action.payload.data },
            }
        default:
            return state
    }
}

export default chartReducer
